exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".send-footer {\n  border-top: 1px solid #bbb;\n  height: 1.9rem;\n  margin-bottom: .188rem;\n  padding: .094rem .188rem .188rem;\n  width: 100%; }\n\n.send-form {\n  width: 100%; }\n\n.send-input {\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/chat/SendFooter.scss
// module id = 216
// module chunks = 0